<template>
  <v-menu
    left
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="430"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>mdi-filter-variant</v-icon>
          </v-btn>
        </template>
        <span>Filtros personalizados</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        Filtros personalizados
      </v-card-title>
      <v-card-text class="text--primary">
        <v-row>
          <v-col cols="12">
            <px-autocomplete-fornecedor-multiple
              :cotacoes="cotacoes"
              v-model="fornecedoresLocal"
              class="rounded-tag-small"
              path="/cotacoes/matriz/fornecedores"
              :disabled="!hasCotacao"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <px-autocomplete-cotacao-produto
              :cotacoes="cotacoes"
              v-model="cotacoesItensLocal"
              class="rounded-tag-small"
              path="/cotacoes/matriz/produtos"
              :disabled="!hasCotacao"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" class="normal-btn-text rounded-tag-small" @click="apply">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    cotacoes: Array,
  },
  data: () => ({
    menuOpened: false,
    fornecedoresLocal: null,
    cotacoesItensLocal: null,
  }),
  computed: {
    hasCotacao() {
      return this.cotacoes && this.cotacoes.length;
    },
    fornecedores: {
      get() {
        return this.$store.getters['matriz/fornecedores'];
      },
      set(fornecedores) {
        this.$store.dispatch('matriz/fornecedores', fornecedores);
      },
    },
    cotacoesItens: {
      get() {
        return this.$store.getters['matriz/cotacoesItens'];
      },
      set(cotacoesItens) {
        this.$store.dispatch('matriz/cotacoesItens', cotacoesItens);
      },
    },
  },
  watch: {
    fornecedores(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (!newValue) {
        this.clear();
      }
    },
    cotacoesItens(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (!newValue) {
        this.clear();
      }
    },
  },
  methods: {
    clear() {
      this.cotacoesItensLocal = null;
      this.fornecedoresLocal = null;
    },
    apply() {
      this.fornecedores = this.fornecedoresLocal ? [...this.fornecedoresLocal] : null;
      this.cotacoesItens = this.cotacoesItensLocal ? [...this.cotacoesItensLocal] : null;
      this.menuOpened = false;
      this.$emit('change');
    },
  },
};
</script>
